"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transitions = void 0;
exports.transitions = {
    duration: {
        shortest: '0.0s',
        default: '0.3s',
    },
};
//# sourceMappingURL=transitions.js.map